
import invoicingtermscoditions from '../api/invoicing_terms_coditions'

export const state = {
  invoicing_terms_coditions: [],
  invoicing_term_codition_pagination_data: {},
  invoicing_term_codition: ''
}

export const getters = {
  invoicing_terms_coditions: state => state.invoicing_terms_coditions,
  invoicing_term_codition_pagination_data: state => state.invoicing_term_codition_pagination_data,
  invoicing_term_codition: state => state.invoicing_term_codition
}

export const mutations = {
  ADD_INVOICING_TC (state, data) {
    state.invoicing_terms_coditions.push(data)
  },
  SET_INVOICING_TC (state, data) {
    state.invoicing_terms_coditions = data
  },
  SET_INVOICING_TC_PAGINATION (state, data) {
    state.invoicing_term_codition_pagination_data = data
  },
  SHOW_INVOICING_TC (state, data) {
    state.invoicing_term_codition = data
  }
}

export const actions = {
  GET_INVOICING_TC ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoicingtermscoditions.get(data).then(response => {
        commit('SET_INVOICING_TC', response.data.data)
        let paginationData = {
          from: response.data.from,
          to: response.data.to,
          total: response.data.total,
          last_page: response.data.last_page
        }
        commit('SET_INVOICING_TC_PAGINATION', paginationData)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  CREATE_INVOICING_TC ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoicingtermscoditions.create(data).then(response => {
        commit('ADD_INVOICING_TC', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  SHOW_INVOICING_TC ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      invoicingtermscoditions.show(id).then(response => {
        commit('SHOW_INVOICING_TC', response.data)
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  EDIT_INVOICING_TC ({ commit, getters }, data) {
    return new Promise((resolve, reject) => {
      invoicingtermscoditions.update(data, state.invoicing_term_codition.id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  },
  REMOVE_INVOICING_TC ({ commit, getters }, id) {
    return new Promise((resolve, reject) => {
      invoicingtermscoditions.delete(id).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice-terms-conditions.js